import React, { Fragment, useState } from "react";
import { Row, Col, Card, CardBody, CardHeader, Button, Input, Form, FormGroup, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import AxiosInstance from "../../services/AxiosInstance";
import "react-toastify/dist/ReactToastify.css";

const AUDIENCE_OPTIONS = [
    { value: "ALL", label: "All" },
    { value: "CUSTOM", label: "Custom" },
    { value: "FILTER", label: "Filter" },
];

const InvitationCampaignCreate = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        campaign_name: "",
        email_subject: "",
        email_template: "",
        audience_type: "CUSTOM",
        scheduled_at: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const defaultTemplate = `<p>Hello,</p>
<p>You have been invited to join as a recruiter on our platform.</p>
<p>Click the link below to create your account:</p>
<p><a href="{invitation_link}" style="display:inline-block;padding:12px 24px;background:#007bff;color:#fff;text-decoration:none;border-radius:6px;">Accept Invitation</a></p>
<p>Or copy: {invitation_link}</p>
<p>Placeholders: {invite_email}, {tracking_pixel_url} (optional 1x1 img for open tracking)</p>`;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.campaign_name.trim()) {
            toast.error("Campaign name is required");
            return;
        }
        setLoading(true);
        try {
            const res = await AxiosInstance().post("/admin/invitation_campaign/store", {
                campaign_name: form.campaign_name.trim(),
                email_subject: form.email_subject.trim(),
                email_template: form.email_template || defaultTemplate,
                audience_type: form.audience_type,
                scheduled_at: form.scheduled_at || undefined,
            });
            if (res.data.status && res.data.campaign_id) {
                toast.success(res.data.message || "Campaign created");
                navigate(`/job/admin/invitation-campaign/${res.data.campaign_id}`);
            } else {
                toast.error(res.data.message || "Create failed");
            }
        } catch (e) {
            toast.error(e.response?.data?.message || "Create failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Breadcrumbs title="Create Campaign" mainTitle="Admin" />
            <Row>
                <Col xs="12">
                    <Card>
                        <CardHeader><h5 className="mb-0">New Invitation Campaign</h5></CardHeader>
                        <CardBody>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <Label>Campaign Name <span className="text-danger">*</span></Label>
                                    <Input type="text" name="campaign_name" value={form.campaign_name} onChange={handleChange} placeholder="Campaign name" required />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Email Subject</Label>
                                    <Input type="text" name="email_subject" value={form.email_subject} onChange={handleChange} placeholder="Email subject" />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Email Template (HTML)</Label>
                                    <Input type="textarea" name="email_template" value={form.email_template} onChange={handleChange} rows={12} placeholder="Use {invitation_link}, {invite_email}, {tracking_pixel_url}" />
                                    <small className="text-muted">Placeholders: {"{invitation_link}"}, {"{invite_email}"}, {"{tracking_pixel_url}"}, {"{system_name}"}, {"{sender_name}"}</small>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Audience Type</Label>
                                    <Input type="select" name="audience_type" value={form.audience_type} onChange={handleChange}>
                                        {AUDIENCE_OPTIONS.map((o) => (
                                            <option key={o.value} value={o.value}>{o.label}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Schedule Time (optional)</Label>
                                    <Input type="datetime-local" name="scheduled_at" value={form.scheduled_at} onChange={handleChange} />
                                </FormGroup>
                                <div className="d-flex gap-2">
                                    <Button color="primary" type="submit" disabled={loading}>{loading ? "Saving…" : "Save Campaign"}</Button>
                                    <Button type="button" color="secondary" onClick={() => navigate("/job/admin/invitation-campaign")}>Cancel</Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <ToastContainer />
        </Fragment>
    );
};

export default InvitationCampaignCreate;
